import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Link2, X } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const input = "w-full h-10 px-3 rounded-lg border border-input text-sm focus:outline-none focus:ring-2 focus:ring-electric";

export function MediaUpload({ value, onChange, label = "Image", testid = "media" }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [url, setUrl] = useState("");

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await api.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.url);
      toast.success("Image uploaded");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-sm text-slate-600">{label}</label>
      {value ? (
        <div className="relative inline-block">
          <img src={value} alt="preview" className="h-28 w-auto rounded-lg border border-slate-200 object-cover" data-testid={`${testid}-preview`} />
          <button type="button" onClick={() => onChange(null)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1" data-testid={`${testid}-remove`}><X className="h-3 w-3" /></button>
        </div>
      ) : (
        <div className="space-y-2">
          <div className="flex gap-2">
            <Button type="button" variant="outline" size="sm" disabled={uploading} onClick={() => fileRef.current?.click()} className="gap-1.5" data-testid={`${testid}-upload-btn`}>
              <Upload className="h-4 w-4" /> {uploading ? "Uploading…" : "Upload"}
            </Button>
            <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`${testid}-file-input`} />
          </div>
          <div className="flex gap-2">
            <input className={input} placeholder="…or paste an image URL" value={url} onChange={(e) => setUrl(e.target.value)} data-testid={`${testid}-url-input`} />
            <Button type="button" variant="outline" size="sm" onClick={() => { if (url.trim()) { onChange(url.trim()); setUrl(""); } }} className="gap-1.5 shrink-0"><Link2 className="h-4 w-4" /> Use URL</Button>
          </div>
        </div>
      )}
    </div>
  );
}
